var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12501 15.5C7.00799 15.5004 6.89322 15.4679 6.79376 15.4062C6.70368 15.35 6.62945 15.2716 6.57805 15.1787C6.52665 15.0857 6.49979 14.9812 6.50001 14.875V8.8625L1.67501 3.50625C1.15861 2.93127 0.8736 2.18533 0.875005 1.4125V1.125C0.875005 0.95924 0.940853 0.800269 1.05806 0.683058C1.17527 0.565848 1.33424 0.5 1.50001 0.5H16.5C16.6658 0.5 16.8247 0.565848 16.9419 0.683058C17.0592 0.800269 17.125 0.95924 17.125 1.125V1.4125C17.1264 2.18533 16.8414 2.93127 16.325 3.50625L11.5 8.8625V12.225C11.5007 12.574 11.4039 12.9163 11.2206 13.2134C11.0373 13.5104 10.7748 13.7503 10.4625 13.9062L7.40626 15.4312C7.31918 15.4759 7.22284 15.4994 7.12501 15.5ZM2.15626 1.75C2.21819 2.09204 2.37399 2.41013 2.60626 2.66875L7.60626 8.20625C7.70366 8.32362 7.75479 8.47255 7.75001 8.625V13.8625L9.90626 12.7875C10.0103 12.7351 10.0976 12.6546 10.1583 12.5553C10.2191 12.4559 10.2508 12.3415 10.25 12.225V8.625C10.2504 8.4701 10.3083 8.32087 10.4125 8.20625L15.4125 2.66875C15.6493 2.4116 15.8095 2.09338 15.875 1.75H2.15626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.f233d061ba589ff8de834c1ce190076b.svg";
export { ForwardRef as ReactComponent };